// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store';
import App from './App';
import { sync } from 'vuex-router-sync';
import router from './router';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

window.Vue = require('vue');

Vue.use(Vuetify);

sync(store, router);

Vue.config.productionTip = false;

Vue.component(
  'loader',
  require('./components/Loader.vue').default
);

Vue.component(
  'ConfirmationDialog',
  require('./components/ConfirmationDialog.vue').default
);

Vue.component(
  'ToastMessage',
  require('./components/ToastMessage.vue').default
);

Vue.component(
  'DataTable',
  require('./components/DataTable.vue').default
);

Vue.component(
  'EditDialog',
  require('./components/EditDialog.vue').default
);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js